import React from 'react';
import './Nav.css'

export default function Nav(props: {
    children: JSX.Element | Array<JSX.Element> | string
}) {
    React.Children.map(props.children, (child) => {
        return <ul>{child}</ul>
    });
    return (
        <div className='nav'>
            <ul>
                {props.children}
            </ul>
        </div>
    )
}